let uiModule = {
    init: () => {
        var isModal = false;

        /* Modal
        --------------------------------------- */

        var MODAL = [{
            title: 'PERSONALISED SHOPPING',
            content: 'E-commerce sites tend to be static – the on the page is the same for everyone. But Watson can help brands create a deeper relationship with customers – making the experience of online shopping less like flicking through endless racks of products and more like talking to an expert assistant.'
        }, {
            title: 'WATSON AT WIMBLEDON',
            content: 'Wimbledon’s “Cognitive Command Centre” was powered by Watson’s intelligence. Human experts taught Watson how to understand social discussion across Twitter, Facebook, Youtube and Instagram. More than 11 million pieces of content were analysed during Wimbledon.'
        }, {
            title: 'BESPOKE BREAKS',
            content: 'WayBlazer, built on Watson’s Natural Language Processing, enables travelers to search in a nuanced, personalised way – and for holiday firms to provide instant, smart answers based not just on data provided by the hotels, but blogs, reviews and more.'
        }, {
            title: 'SOCIAL GETS SMART',
            content: 'Beyond being able to recognise words and phrases, Watson can tap into the emotion and context of fast-moving social media – such as the conversation around sporting events. By understanding language and nuance, it can access and understand blogs, reviews, pictures and videos – unstructured data invisible to traditional search.'
        }, {
            title: 'COOKING WITH COGNITIVE',
            content: 'Chef Watson can generate an infinite number of recipes, based on its training from Condé Nast’s Bon Appétit magazine. The ability for Watson to learn and be taught as opposed to programmed opens up a world of possibilities for its application.'
        }];


        /* Alert
        --------------------------------------- */

        var $alert = $('.wd-alert');
        var $alertBtn = $('.wd-alert_button a');

        $alertBtn.on('click', closeAlert);

        function closeAlert() {
            $alert.hide();
        }



        /* Modal
        --------------------------------------- */

        var $window = $(window);
        var $body = $('body');
        var $modal = $('.wd-modal');
        var $modalBtn = $('.wd-modal_close');

        $modalBtn.on('click', closeModal);
        $body.on('click', closeModal);
        $body.on('click', closeAlert);
        $modal.on('click', preventClose);



        function preventClose(e) {
            e.stopPropagation();
        }

        function closeModal() {
            isModal = false;
            $modal.removeClass('wd-modal_show');
            $content.removeClass(function(index, css) {
                return (css.match(/\bwd-zoom_\S+/g) || []).join(' ');
            });
            pointOut();
        }



        /* Points
        --------------------------------------- */


        var $point = $('div[data-point]');
        var $svg = $('.wd-svg svg');
        var $circle = $('circle[data-point]');
        var $zone = $('.wd-zone');
        var $content = $('.valign-wrap');


        pointPosition();
        $window.on('resize', pointPosition);


        $point.on('mouseover', pointOver);
        $point.on('mouseout', pointOut);
        $point.on('click', function(e) {
            var $this = $(this);
            var point = $this.data('point');
            preventClose(e);
            pointClick($this);
            $content.addClass('wd-zoom_' + point);
        });




        function pointPosition() {
            $circle.each(function() {

                var svgLeft = $svg.offset().left;
                var svgTop = $svg.offset().top;

                var left = $(this).offset().left;
                var top = $(this).offset().top;

                var point = $(this).data('point');
                var offsetLeft = ($('div[data-point="' + point + '"]').width() - $(this)[0].getBoundingClientRect().width) / 2;
                var offsetTop = ($('div[data-point="' + point + '"]').height() - $(this)[0].getBoundingClientRect().height) / 2;


                $('div[data-point="' + point + '"]').css({
                        left: left - svgLeft - offsetLeft,
                        top: top - svgTop - offsetTop
                    })
                    .fadeIn();
            });
        }


        function pointOver() {
            var index = $(this).data('point');

            $zone.each(function() {
                var zone = $(this).data('zone');

                if (index !== zone) {
                    $(this).addClass('wd-zone_faded');
                }
            })
        }



        function pointOut() {
            if (!isModal) {
                $zone.removeClass('wd-zone_faded');
            }
        }



        function pointClick($this) {
            var index = $this.data('point');
            var title = MODAL[index].title;
            var content = MODAL[index].content;

            isModal = true;

            $modal.find('.wd-modal_title').text(title);
            $modal.find('.wd-modal_content').text(content);
            $modal.addClass('wd-modal_show');
        }
    }
};

$(document).ready(uiModule.init);
